import React from 'react';

function TextArea({ placeholder, nameInput }) {
  return (
    <textarea
      className={`bg-amber border-amber text-gray200 border placeholder-textColor focus:placeholder:text-gray700 text-lg rounded-lg focus:ring-gray-500 focus:border-gray500 focus:outline-none w-10/12 min-h-20 p-3 m-2 focus:bg-[#eee] focus:text-gray500 focus:font-semibold resize-y transition-all`}
      placeholder={placeholder}
      name={nameInput}
      rows='3'
    ></textarea>
  );
}

export default TextArea;
